import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { of } from 'rxjs';
import { FindIotpSuiteCredentialResponse } from '../models/layout/app_rspmbridge/FindIotpSuiteCredential';

@Injectable({
    providedIn: 'root'
})
export class EuiccsService {

    private euiccValidApi = this.apiService.get<{ cmd: FindIotpSuiteCredentialResponse }>("app_rspmbridge.set_iotsuite_org_credential", { validateOnly: true }).pipe(shareReplay(1), map(res => res.cmd.success));
    euiccEnabled$ = this.sessionService.session$.pipe(map( session => session.euiccEnabled));
    rspmEnabled$ = this.euiccEnabled$.pipe(switchMap(res => res ? this.euiccValidApi : of(res)));

    constructor(
        private readonly sessionService: SessionService,
        private readonly apiService: ApiService
    ) { }
}
